import React, { Component } from 'react';
import VoucherMain from '../../../components/User/Voucher/voucher.main'
import LayoutPreload from '../../../components/Preload/layout.preload';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../store/actions';
import _ from 'lodash';

class UserVoucher extends Component {
    componentDidMount() {
        const { GetVoucher, isAuthenticated, updateWording } = this.props;
        updateWording();
        if (isAuthenticated) {
            GetVoucher();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            !_.isEqual(prevProps.isAuthenticated, this.props.isAuthenticated) ||
            !_.isEqual(prevProps.currentLanguage, this.props.currentLanguage)
        ) {
            if (this.props.isAuthenticated) {
                const { GetVoucher } = this.props;
                GetVoucher();
            }
        }
    }

    render() {
        const { isFetching } = this.props;
        if (isFetching) return <LayoutPreload />;

        return <VoucherMain />;
    }
}

const mapStateToProps = ({ user, login, language }) => ({
    isFetching: user.voucher.isFetching,
    isError: user.voucher.error,
    isAuthenticated: login.isAuthenticated,
    currentLanguage: language.currentLanguage
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            GetVoucher: Actions.GetVoucherByCustomerId,
            updateWording: Actions.updateWording
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserVoucher);
